import { render, staticRenderFns } from "./EmailFiles.vue?vue&type=template&id=112b72da"
import script from "./EmailFiles.vue?vue&type=script&lang=js"
export * from "./EmailFiles.vue?vue&type=script&lang=js"
import style0 from "./EmailFiles.vue?vue&type=style&index=0&id=112b72da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports